import { Injectable, computed, inject, signal } from '@angular/core';
import { ConfigStateService, CurrentUserDto } from '@abp/ng.core';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly configState = inject(ConfigStateService);

  readonly currentUser = signal<CurrentUserDto | null>(null);
  readonly grantedPolicies = signal<Record<string, boolean>>({});

  readonly isAuthenticated = computed(() => this.currentUser()?.isAuthenticated ?? false);
  readonly isLoggedIn = computed(() => this.isAuthenticated());
  readonly userName = computed(() => this.currentUser()?.userName ?? '');
  readonly fullName = computed(
    () => this.currentUser()?.name || this.currentUser()?.surName || this.currentUser()?.userName || '',
  );
  readonly roles = computed(() => this.currentUser()?.roles ?? []);

  constructor() {
    this.configState.getOne$('currentUser').subscribe((user) => this.currentUser.set(user ?? null));
    this.configState.getOne$('auth').subscribe((auth) => this.grantedPolicies.set(auth?.grantedPolicies ?? {}));
  }

  hasPermission(permission: string): boolean {
    return this.grantedPolicies()[permission] === true;
  }
}
